import { defineStore } from 'pinia'

export const usePesquisaStore = defineStore('pesquisa', {
    state: () => ({
        estaAbertaPesquisa: false,
        estaAbertoMenu: false,
        termoPesquisa: '',
    }),

    actions: {
        setEstaAbertaPesquisa(valor) {
            this.estaAbertaPesquisa = valor
        },

        setEstaAbertoMenu(valor) {
            this.estaAbertoMenu = valor
        },

        setTermoPesquisa(valor) {
            this.termoPesquisa = valor || ''
        },

        limparPesquisa() {
            this.termoPesquisa = ''
        },
    },
})